/**
 * The report-family tab segments — the leaves that make a section's detail its own (deepest) screen. A tab
 * missing here opens at the wrong depth: the stack stays on the integrants level and the back chevron pops the
 * wrong way. A LEAF module for the same reason as `pane-metrics`: `ListPanePending` asks the same question of
 * the url and stays in the entry bundle, so reading it off `section-stack` would drag the nav stack in with it.
 */
export const REPORT_TAB_SEGMENTS = ['report', 'board', 'distribution', 'evaluation', 'evaluate'] as const

export type ReportTabSegment = (typeof REPORT_TAB_SEGMENTS)[number]

export const REPORT_TAB = new RegExp(`/(${REPORT_TAB_SEGMENTS.join('|')})/?$`)

/** Which of those tabs a pathname names, or `undefined` for the item's own screen, where that pane is empty. */
export function reportTabOf(pathname: string): ReportTabSegment | undefined {
  return REPORT_TAB.exec(pathname)?.[1] as ReportTabSegment | undefined
}

/** The tab bar's active member: a substring match, so a trailing segment below the tab still counts. */
export function activeReportTab(pathname: string): ReportTabSegment {
  return (
    (['distribution', 'board', 'evaluation', 'evaluate'] as const).find((k) => pathname.includes(`/${k}`)) ?? 'report'
  )
}

/** A report control writing the profile search lands on the Report tab: the other tabs don't render that search. */
export function reportTabPath(pathname: string): string {
  return pathname.replace(/\/(distribution|board|evaluate|evaluation)/, '/report')
}
